// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** @param {import('@liquidweb-dev/undercurrent/Box').BoxProps} props */
const CardLayeredHeader = ({ sx, ...rest }) => (
	<Box
		sx={combineSx(
			{
				marginBottom: -150,
				padding: 200,
				paddingBottom: 300,
				backgroundColor: ({ vars }) => vars.palette.uc.bg.weak,
				borderTopLeftRadius: ({ borderRadius }) => borderRadius.rounded,
				borderTopRightRadius: ({ borderRadius }) => borderRadius.rounded,
			},
			sx,
		)}
		{...rest}
	/>
);

export default CardLayeredHeader;
